(function () {
  const RADIO_CONTAINER_ID = "search-results-region";

  const FILTERS_CONTAINER_SELECTOR = ".strmpr-search-result-filters";
  const DROPDOWN_SELECTOR = "#storemapper-filter-drop-down-0";
  const BUTTON_SELECTOR = "#storemapper-filter-0 span";

  const RESULTS_SELECTOR = ".strmpr-search-results";
  const RESULT_ITEM_SELECTOR = ".strmpr-search-result";
  const MOVE_FIELD_SELECTOR =
    ".strmpr-field-bucket-general .strmpr-field-custom.store_type";
  const INSERT_AFTER_SELECTOR = ".strmpr-google-details-header";

  const RADIO_GROUP_NAME = "region";
  const RADIO_ACTIVE_CLASS = "is-active";

  /* --------------------------------------------------
     Ensure / move radio container
  -------------------------------------------------- */
  function ensureRadioContainer() {
    let radioContainer = document.getElementById(RADIO_CONTAINER_ID);
    const filtersContainer = document.querySelector(FILTERS_CONTAINER_SELECTOR);
    if (!filtersContainer) return null;

    if (!radioContainer) {
      radioContainer = document.createElement("div");
      radioContainer.id = RADIO_CONTAINER_ID;
    }

    if (radioContainer.parentElement !== filtersContainer) {
      filtersContainer.appendChild(radioContainer);
    }

    return radioContainer;
  }

  /* --------------------------------------------------
     Dropdown helpers
  -------------------------------------------------- */
  function triggerChange(el) {
    el.dispatchEvent(new Event("change", { bubbles: true }));
  }

  function clearDropdownSelection(dropdownRoot) {
    dropdownRoot
      .querySelectorAll("input.storemapper-filter-checkbox")
      .forEach((cb) => {
        if (cb.checked) {
          cb.checked = false;
          triggerChange(cb);
        }
      });
  }

  function selectDropdownValue(dropdownRoot, valueToSelect) {
    const target = dropdownRoot.querySelector(
      `input.storemapper-filter-checkbox:not(.storemapper-filter-all)[value="${CSS.escape(
        valueToSelect
      )}"]`
    );
    if (!target) return;

    clearDropdownSelection(dropdownRoot);
    target.checked = true;
    triggerChange(target);
  }

  function selectDropdownAll(dropdownRoot) {
    const selectAll = dropdownRoot.querySelector(
      "input.storemapper-filter-all"
    );
    if (!selectAll) return;

    clearDropdownSelection(dropdownRoot);
    selectAll.checked = true;
    triggerChange(selectAll);
  }

  function setActiveRadio(radioContainer, selectedRadio) {
    radioContainer
      .querySelectorAll(`.${RADIO_ACTIVE_CLASS}`)
      .forEach((el) => el.classList.remove(RADIO_ACTIVE_CLASS));

    const wrapper = selectedRadio.closest("[data-radio-wrapper]");
    if (wrapper) wrapper.classList.add(RADIO_ACTIVE_CLASS);
  }

  /* --------------------------------------------------
     Build radios (with Select All)
  -------------------------------------------------- */
  function buildRadios(dropdownRoot) {
    const radioContainer = ensureRadioContainer();
    if (!radioContainer || radioContainer.dataset.built === "1") return;

    // Section title
    const buttonSpan = document.querySelector(BUTTON_SELECTOR);
    if (buttonSpan) {
      const title = document.createElement("h4");
      title.textContent = buttonSpan.textContent.trim();
      radioContainer.appendChild(title);
    }

    const wrappersFragment = document.createDocumentFragment();

    // ---- SELECT ALL RADIO ----
    const selectAllCheckbox = dropdownRoot.querySelector(
      "input.storemapper-filter-all"
    );

    if (selectAllCheckbox) {
      const wrapper = document.createElement("div");
      wrapper.setAttribute("data-radio-wrapper", "1");

      const radio = document.createElement("input");
      radio.type = "radio";
      radio.name = RADIO_GROUP_NAME;
      radio.value = "__all__";
      radio.id = "region-radio-all";

      const label = document.createElement("label");
      label.htmlFor = radio.id;
      label.textContent = "Select All";

      if (selectAllCheckbox.checked) {
        radio.checked = true;
        wrapper.classList.add(RADIO_ACTIVE_CLASS);
      }

      radio.addEventListener("change", () => {
        if (!radio.checked) return;
        setActiveRadio(radioContainer, radio);
        selectDropdownAll(dropdownRoot);
      });

      wrapper.appendChild(radio);
      wrapper.appendChild(label);
      wrappersFragment.appendChild(wrapper);
    }

    // ---- REGION RADIOS ----
    const checkboxes = dropdownRoot.querySelectorAll(
      "input.storemapper-filter-checkbox:not(.storemapper-filter-all)"
    );

    checkboxes.forEach((checkbox, idx) => {
      const labelEl = dropdownRoot.querySelector(`label[for="${checkbox.id}"]`);
      const labelText = labelEl ? labelEl.textContent.trim() : checkbox.name;

      const radioId = `region-radio-${idx}`;

      const wrapper = document.createElement("div");
      wrapper.setAttribute("data-radio-wrapper", "1");

      const radio = document.createElement("input");
      radio.type = "radio";
      radio.name = RADIO_GROUP_NAME;
      radio.value = checkbox.value;
      radio.id = radioId;

      const label = document.createElement("label");
      label.htmlFor = radioId;
      label.textContent = labelText;

      if (checkbox.checked) {
        radio.checked = true;
        wrapper.classList.add(RADIO_ACTIVE_CLASS);
      }

      radio.addEventListener("change", () => {
        if (!radio.checked) return;
        setActiveRadio(radioContainer, radio);
        selectDropdownValue(dropdownRoot, radio.value);
      });

      wrapper.appendChild(radio);
      wrapper.appendChild(label);
      wrappersFragment.appendChild(wrapper);
    });

    radioContainer.appendChild(wrappersFragment);
    radioContainer.dataset.built = "1";
  }

  /* --------------------------------------------------
     Move store_type under google header
  -------------------------------------------------- */
  function moveStoreTypeFields() {
    document
      .querySelectorAll(`${RESULTS_SELECTOR} ${RESULT_ITEM_SELECTOR}`)
      .forEach((result) => {
        const storeType = result.querySelector(MOVE_FIELD_SELECTOR);
        const header = result.querySelector(INSERT_AFTER_SELECTOR);

        if (
          storeType &&
          header &&
          storeType.previousElementSibling !== header
        ) {
          header.insertAdjacentElement("afterend", storeType);
        }
      });
  }

  /* --------------------------------------------------
     Init (async-safe)
  -------------------------------------------------- */
  function tryInit() {
    const dropdownRoot = document.querySelector(DROPDOWN_SELECTOR);
    const filtersContainer = document.querySelector(FILTERS_CONTAINER_SELECTOR);

    if (dropdownRoot && filtersContainer) {
      buildRadios(dropdownRoot);
      //moveStoreTypeFields();
      return true;
    }
    return false;
  }

  if (tryInit()) return;

  const observer = new MutationObserver(() => {
    if (tryInit()) observer.disconnect();
  });

  observer.observe(document.documentElement, {
    childList: true,
    subtree: true
  });
})();
